import { carouselStyles } from "@insite/content-library/Components/ProductCompareCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css, ThemeProps, withTheme } from "styled-components";

carouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 5px;
                    margin-left: -12px;
                    width: 26px;
                `,
            ])};
    `,
};
carouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 5px;
                    margin-right: -12px;
                    width: 26px;
                `,
            ])};
    `,
};
carouselStyles.carouselContentEmptyCellGridItem = {
    width: [3, 3, 2, 2, 2],
};
carouselStyles.carouselCellGridItem = {
    width: [9, 9, 10, 10, 10],
    css: css`
        background: ${getColor("common.accent")};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    max-width: 100%;
                    flex-basis: 100%;
                    background: none;
                `,
            ])}
    `,
};

carouselStyles.carouselSlidesContainer = {
    css: css`
        display: flex;
        > div {
            padding: 10px;
        }
    `,
};

carouselStyles.carouselSlide = {
    css: css`
        padding: 10;
        position: relative;
        flex: 0 0 auto;
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 15px;
        display: flex;
        flex-direction: column;
        border: 1px solid rgb(227, 227, 227);
        background: #fff;
        [data-test-selector="productContainer"]{
            > div[class^="GridOffset"]{
                > div:first-child {
                    align-items: center;
                    height:270px;
                }
            }
        }
        [data-test-selector="addToListLink"] {
            cursor: pointer;
            font-family: inherit;
            height: 40px;
            line-height: 1;
            background: transparent;
            border: 2px solid rgb(145, 161, 163);
            color: rgb(54, 54, 54);
            width: 100%;
            padding: 0px 12px;
            text-transform: uppercase;
            margin: 0px;
            display: flex;s
            -webkit-box-pack: center;
            justify-content: center;
            > span{
                color: #91a2a4 !important;
                font-weight: 700;
            }
            &:hover {
                background: #69a342;
                border: 2px solid #69a342;
                >span{
                    color: #fff !important;
                }
            }
        }
    `,
};
carouselStyles.attributeLabelsCellGridItem = {
    width: [4, 4, 2, 2, 2],
    css: css`
        border-left: 1px solid rgb(227, 227, 227);
        border-top: 1px solid rgb(227, 227, 227);
        margin-top: 20px !important;
        border-right: none;
    `,
};
carouselStyles.attributeLabelsGridContainer = {
    gap: 0,
    css: css`
        z-index: 1;
    `,
};
carouselStyles.attributeValuesCellGridItem = {
    width: [8, 8, 10, 10, 10],
    css: css`
        padding: 20px 0px 0px 0px;
    `,
};
carouselStyles.attributeValuesWrapper = {
    css: css`
        width: 100%;
        position: relative;
        border: 1px solid rgb(227, 227, 227);
    `,
};
